import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { styled } from "@mui/material";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";

interface IProps extends IWithClassName {
    isSort: boolean;
    sortDirection: "asc" | "desc" | null;
}

const TableArrow = ({ isSort, sortDirection, className }: IProps) => {
    const getSortArrow = (sortDirection: "asc" | "desc" | null) =>
        sortDirection === "asc" ? (
            <ArrowDropUp className="sortIcon" />
        ) : (
            <ArrowDropDown className="sortIcon" />
        );

    return (
        <span className={className}>
            {isSort ? (
                getSortArrow(sortDirection)
            ) : (
                <>
                    <ArrowDropUp className="sortIconUp sortIcon" />
                    <ArrowDropDown className="sortIconDown sortIcon" />
                </>
            )}
        </span>
    );
};

export default styled(TableArrow)(({ theme }: IWithThemeProps) => ({
    display: "grid",
    ".sortIconUp": {
        marginBottom: -9,
    },
    ".sortIconDown": {
        marginTop: -9,
    },
    ".sortIcon": {
        color: theme?.palette.listsTable.sortIconColor,
    },
}));
